import {useState} from "react"
import {Link} from "react-router-dom"
import ServicesDropdown from "./ServicesDropdown"

export default function Navbar(){
 const [menuOpen,setMenuOpen]=useState(false)

 const closeMenu=()=>setMenuOpen(false)

 return(
  <nav className="nav">

   <Link className="logo" to="/" aria-label="KPLInfotech home" onClick={closeMenu}>
    <span className="logo-mark">K</span>
    <div>
     <h3>KPLInfotech</h3>
     <span>Digital Solutions</span>
    </div>
   </Link>

   <button
    className={`menu-toggle ${menuOpen ? "active" : ""}`}
    type="button"
    aria-label="Toggle navigation menu"
    aria-expanded={menuOpen}
    onClick={()=>setMenuOpen(!menuOpen)}
   >
    <span></span>
    <span></span>
    <span></span>
   </button>

   <ul className={`menu ${menuOpen ? "open" : ""}`}>
    <li><Link to="/" onClick={closeMenu}>Home</Link></li>
    <li><Link to="/career" onClick={closeMenu}>Career</Link></li>
    <ServicesDropdown onNavigate={closeMenu}/>
    <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
   </ul>

  </nav>
 )
}
